import { createUseStyles } from 'react-jss';

import { PositiveColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  {
    root: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto 1fr auto',
      gridTemplateAreas: "'header' 'main' 'footer'",
      minHeight: '100vh',
      filter: (props: any) => props.blurred && 'blur(4px)',
    },

    section: {
      minWidth: 0,
      minHeight: 0,

      '&.header': {
        position: 'relative',
        zIndex: 6,
        gridArea: 'header',
      },
      '&.main': {
        gridArea: 'main',
      },
      '&.footer': {
        gridArea: 'footer',
      },
    },

    headerContainer: {
      backgroundColor: PositiveColors.base.default,
      position: 'sticky',
      top: 0,
      zIndex: 4,
    },
  },
  {
    name: 'layout',
  },
);

export default useStyles;
